import { render, staticRenderFns } from "./InteractiveCubes.vue?vue&type=template&id=4fd96085&scoped=true&"
import script from "./InteractiveCubes.vue?vue&type=script&lang=js&"
export * from "./InteractiveCubes.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveCubes.vue?vue&type=style&index=0&id=4fd96085&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd96085",
  null
  
)

export default component.exports